/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Value_No_PainInputs */

const en_us2_search_value_no_pain = /** @type {(inputs: Search_Value_No_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None`)
};

const pt_br2_search_value_no_pain = /** @type {(inputs: Search_Value_No_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma`)
};

const es_419_search_value_no_pain = /** @type {(inputs: Search_Value_No_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ninguno`)
};

const pt_pt2_search_value_no_pain = /** @type {(inputs: Search_Value_No_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma`)
};

const fr_fr2_search_value_no_pain = /** @type {(inputs: Search_Value_No_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune`)
};

const de_de2_search_value_no_pain = /** @type {(inputs: Search_Value_No_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine`)
};

const it_it2_search_value_no_pain = /** @type {(inputs: Search_Value_No_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuno`)
};

/**
* | output |
* | --- |
* | "None" |
*
* @param {Search_Value_No_PainInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_value_no_pain = /** @type {((inputs?: Search_Value_No_PainInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Value_No_PainInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_value_no_pain(inputs)
	if (locale === "es-419") return es_419_search_value_no_pain(inputs)
	if (locale === "pt-PT") return pt_pt2_search_value_no_pain(inputs)
	if (locale === "fr-FR") return fr_fr2_search_value_no_pain(inputs)
	if (locale === "de-DE") return de_de2_search_value_no_pain(inputs)
	if (locale === "it-IT") return it_it2_search_value_no_pain(inputs)
	return en_us2_search_value_no_pain(inputs)
});
export { search_value_no_pain as "search.value_no_pain" }